import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { logoutUser } from "../auth/googleAuth";
import {
  MdDashboard,
  MdDataUsage,
  MdPhoneAndroid,
  MdBuildCircle,
  MdSms,
  MdExitToApp,
  MdCloudDownload,
  MdShowChart,
} from "react-icons/md";

const navItems = [
  { label: "Dashboard",       path: "/home",             Icon: MdDashboard     },
  { label: "Data Usage",      path: "/data-usage",       Icon: MdDataUsage     },
  { label: "Device Info",     path: "/device-info",      Icon: MdPhoneAndroid  },
  { label: "Device Diagnose", path: "/device-diagnose",  Icon: MdBuildCircle   },
  { label: "Send SMS",        path: "/send-sms",         Icon: MdSms           },
  { label: "Fetch Bulk Data", path: "/fetch-bulk-data",  Icon: MdCloudDownload },
  { label: "Packet Decode",   path: "/packet-decode",    Icon: MdShowChart     },
];

const Layout = ({ children, title }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const userid = localStorage.getItem("tnt_userid");
  const orgname = localStorage.getItem("tnt_orgname");

  const handleLogout = () => {
    logoutUser();
    navigate("/");
  };

  const initials = userid ? userid.slice(0, 2).toUpperCase() : "?";

  return (
    <div className="flex h-screen overflow-hidden" style={{ backgroundColor: "#111111" }}>
      {/* ── Sidebar ── */}
      <aside className="w-64 flex-shrink-0 flex flex-col" style={{ backgroundColor: "#1c1c1c", borderRight: "1px solid #2a2a2a" }}>
        {/* Logo */}
        <div className="px-6 py-5" style={{ borderBottom: "1px solid #2a2a2a" }}>
          <img
            src="https://www.trakntell.com/wp-content/uploads/2020/10/logo_footer.png"
            alt="Trakntell"
            className="h-8 object-contain"
          />
        </div>

        {/* Nav */}
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          <p className="px-3 pb-2 text-xs font-semibold uppercase tracking-wider" style={{ color: "#555555" }}>
            Menu
          </p>
          {navItems.map(({ label, path, Icon }) => {
            const active = location.pathname === path;
            return (
              <button
                key={path}
                onClick={() => navigate(path)}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors"
                style={
                  active
                    ? { backgroundColor: "#ffc20e", color: "#000000" }
                    : { color: "#aaaaaa" }
                }
                onMouseEnter={(e) => {
                  if (!active) {
                    e.currentTarget.style.backgroundColor = "#2a2a2a";
                    e.currentTarget.style.color = "#ffffff";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!active) {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#aaaaaa";
                  }
                }}
              >
                <Icon className="text-lg flex-shrink-0" />
                {label}
              </button>
            );
          })}
        </nav>

        {/* User + Logout */}
        <div className="px-4 py-4" style={{ borderTop: "1px solid #2a2a2a" }}>
          {userid && (
            <div className="flex items-center gap-3 mb-3">
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
                style={{ backgroundColor: "#ffc20e", color: "#000000" }}
              >
                {initials}
              </div>
              <div className="min-w-0">
                {orgname && <p className="text-sm font-semibold truncate" style={{ color: "#ffffff" }}>{orgname}</p>}
              </div>
            </div>
          )}
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors"
            style={{ color: "#ef4444" }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#2a2a2a"; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
          >
            <MdExitToApp className="text-lg" />
            Logout
          </button>
        </div>
      </aside>

      {/* ── Main Content ── */}
      <main className="flex-1 flex flex-col overflow-hidden">
        {/* Top bar */}
        <header className="px-8 py-4 flex-shrink-0" style={{ backgroundColor: "#1c1c1c", borderBottom: "1px solid #2a2a2a" }}>
          <h1 className="text-xl font-semibold" style={{ color: "#ffffff" }}>{title || "Dashboard"}</h1>
        </header>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
